import React from 'react';
import Banner from '../Components/Banner';
import { Link } from 'react-router-dom';

const PaymentSuccess = () => {
    return (
        <>
            <Banner heading="Payment Successful" text="Success" />
            <div className="tmp-section-gap">
                <div className="container">
                    <div className="service-card-v2 text-center py-16 px-6 max-w-2xl mx-auto">
                        <div className="mb-8">
                            <span className="text-6xl">✅</span>
                        </div>
                        <h2 className="title mb-4">Thank You!</h2>
                        <h3 className="service-card-num mb-6">Your transaction was completed successfully.</h3>
                        <p className="service-para mb-8">
                            We have received your payment details. Our team will contact you shortly regarding the next steps for your project. A confirmation email has been sent to your registered address.
                        </p>
                        <div className="flex flex-wrap justify-center gap-4">
                            <Link to="/" className="tmp-btn btn-primary">Back to Home</Link>
                            <Link to="/contact" className="tmp-btn border border-gray-300 bg-transparent text-gray-800 hover:bg-gray-100">Contact Support</Link>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default PaymentSuccess;
